import Axios from "axios";
import {
    SET_CONSIGNMENT_WISE_PROFIT_LOSS_REPORT,
    UNSET_CONSIGNMENT_WISE_PROFIT_LOSS_REPORT,
} from "@/store/mutation-types";
import { getConsignmentWiseProfitLossReport } from "@/store/api";

const state = {
    getConsignmentWiseProfitLossReport: [],
};

const getters = {
    getConsignmentWiseProfitLossReport(state) {
        return state.getConsignmentWiseProfitLossReport;
    },
};

const mutations = {
    [SET_CONSIGNMENT_WISE_PROFIT_LOSS_REPORT](state, data) {
        state.getConsignmentWiseProfitLossReport = data;
    },
    [UNSET_CONSIGNMENT_WISE_PROFIT_LOSS_REPORT](state) {
        state.getConsignmentWiseProfitLossReport = [];
    },
};

const actions = {
    getConsignmentWiseProfitLossReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getConsignmentWiseProfitLossReport, { params: data })
                .then((response) => {
                    commit(SET_CONSIGNMENT_WISE_PROFIT_LOSS_REPORT, response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_CONSIGNMENT_WISE_PROFIT_LOSS_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};